const LOLOYAL_UPDATE_SCOPES_TIMESTAMP = process.env.PUBLIC_LOLOYAL_UPDATE_SCOPES

const checkNeedUpdateScopes = (jwtExpTime: number) => {
  if (LOLOYAL_UPDATE_SCOPES_TIMESTAMP) {
    const duration30Days = 30 * 24 * 60 * 60
    // 如果jwt的过期时间小于发版时间+30天，就需要重新获取权限
    return jwtExpTime < Number(LOLOYAL_UPDATE_SCOPES_TIMESTAMP) + duration30Days
  }
  return false
}

export const checkExpired = (token: string) => {
  if (!token) return true
  const currentTime = Date.now() / 1000 + 3000
  const payloadString = token.split('.')[1]

  let expTime = 0
  try {
    expTime = JSON.parse(atob(payloadString)).exp
  } catch {
    return true
  }

  return currentTime > expTime || checkNeedUpdateScopes(expTime)
}
